/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelInfoPacketHeader.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/info-packet-header";

export class AutogenModelInfoPacketHeader<RowType extends ModelRow> extends Endpoint<RowType, RowInfoPacketHeaderFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowInfoPacketHeader extends ModelRow<RowInfoPacketHeaderFields> {
	constructor(values?: Partial<RowInfoPacketHeaderFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowInfoPacketHeaderFields {
	comments: string;
	company_id: string;
	descr: string;
	id: string;
}

